<!-- Impressive Stats Section -->
<section class="stats-section">
  <div class="section-container">
    <div class="stats-grid">
      <div class="stat-card" *ngFor="let stat of achievements; let i = index" [style.animation-delay.ms]="i * 200">
        <div class="stat-icon-wrapper">
          <span class="stat-icon">{{ stat.icon }}</span>
          <div class="icon-glow"></div>
        </div>
        <div class="stat-content">
          <div class="stat-number" [attr.data-target]="stat.number">{{ stat.displayNumber }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
        <div class="stat-shine"></div>
      </div>
    </div>
  </div>
</section>